import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IOpportunityContact } from '@/types/opportunity/models'
import type { TEntityId } from '~/types/models'
import {
  getContactListData,
  _getCDataById,
} from '~/api/msw/api/contacts/mockData'

const opportunityContactListData = undefined as unknown as IOpportunityContact[]

export const getOpportunityContactListData = getListDataFunctionFactory<
  IOpportunityContact[]
>({
  listData: opportunityContactListData,
  storageKey: 'opportunitycontacts',
  getStartingListData: getStartingOportunityContactListData,
})

export async function getOpportunityContactDataById(id: string) {
  const list = await getOpportunityContactListData()
  if (!list) {
    throw new Error(`getOpportunityContactListData returned undefined/null`)
  }
  return list.find((oc: IOpportunityContact) => oc.id === id)
}

export async function getOpportunityContactListDataByOpportunityId(
  id: TEntityId
): Promise<IOpportunityContact[]> {
  const list: IOpportunityContact[] = await getOpportunityContactListData()
  if (!list) {
    throw new Error(`getOpportunityContactListData returned undefined/null`)
  }
  const contacts = list.filter((oc) => oc.opportunity.id === id) ?? []
  return contacts
}

export async function getStartingOportunityContactListData(): Promise<
  IOpportunityContact[]
> {
  const cList = await getContactListData()
  const o0003 = { id: 'XXO0003', label: 'DIA - All Locations' }
  return [
    {
      id: 'XXOC0001',
      hrid: 'OC0001',
      opportunity: o0003,
      contact: _getCDataById('XXCCT0001', cList)!,
      splitFraction: 0.1,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOC0002',
      hrid: 'OC0002',
      opportunity: o0003,
      contact: _getCDataById('XXSCT0002', cList)!,
      splitFraction: null,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
